import { connectMsTeamstoProject } from './connect-msteam-to-project';
import { connectSlackToProject } from './connect-slack-to-project';
import { connectZoomToProject } from './connect-zoom-to-project';
import { fetchChatopsEntitlementAction } from './fetch-chatops-entitlement';
import { fetchConfluenceConfiguration } from './fetch-confluence-configuration';
import { fetchMsTeamWorkspaceConnectionForProject } from './fetch-msteam-workspace-connections';
import { fetchResponderAlertsConfiguration } from './fetch-responder-alerts-configuration';
import { fetchSlackWorkspaceConnectionsForProject } from './fetch-slack-workspace-connections';
import { fetchZoomWorkspaceConnectionForProject } from './fetch-zoom-workspace-connections';
import { isMsTeamsConnected } from './is-msteams-enabled';
import { isZoomConnected } from './is-zoom-enabled';
import { removeSlackWorkspaceConnectionsForProject } from './remove-slack-workspace-connection';
import {
	setConfluenceSpace,
	setConfluencePage,
	clearConfluencePage,
	resetSelectedConfluenceConfig,
} from './set-confluence-options';
import { setMsTeamsWorkspaceConnectionStateForProject } from './set-msteam-workspace-connection-state';
import { setPIRConfiguration } from './set-pir-configuration';
import { setResponderAlertsConfiguration } from './set-responder-alerts-configuration';
import { setZoomWorkspaceConnectionStateForProject } from './set-zoom-workspace-connection-state';

export const actions = {
	connectMsTeamstoProject,
	connectZoomToProject,
	fetchZoomWorkspaceConnectionForProject,
	fetchResponderAlertsConfiguration,
	fetchMsTeamWorkspaceConnectionForProject,
	setResponderAlertsConfiguration,
	fetchSlackWorkspaceConnectionsForProject,
	removeSlackWorkspaceConnectionsForProject,
	fetchConfluenceConfiguration,
	setConfluenceSpace,
	setConfluencePage,
	clearConfluencePage,
	resetSelectedConfluenceConfig,
	setPIRConfiguration,
	isMsTeamsConnected,
	isZoomConnected,
	setMsTeamsWorkspaceConnectionStateForProject,
	setZoomWorkspaceConnectionStateForProject,
	connectSlackToProject,
	fetchChatopsEntitlementAction,
} as const;

export type Actions = typeof actions;
